/*
 * Search UI:
 *  - live suggestions for every form[data-cyb-search]; the HTML (already
 *    ranked with the theme's search weights) comes from
 *    sections/cyb-predictive-search.liquid via the Section Rendering API
 *  - sort / "in stock only" toolbar on the search results page
 */
(function () {
  'use strict';

  var script = document.getElementById('CybSearchScript');
  var SUGGEST_URL = (script && script.getAttribute('data-suggest-url')) || '/search/suggest';
  var SECTION_ID = 'cyb-predictive-search';
  /* Not highlighted (same defaults as the "Cuvinte ignorate" theme setting) */
  var STOP = ' de din cu si la pe pentru pt al a o un una sau fara ';
  var cache = {};

  function fold(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  /* Bold the typed words in suggestion titles, ignoring case and diacritics */
  function highlight(root, raw) {
    var words = fold(raw).split(/[^a-z0-9]+/).filter(function (w) {
      return w.length > 1 && STOP.indexOf(' ' + w + ' ') === -1;
    });
    if (!words.length) return;
    var re = new RegExp('(^|[^a-z0-9])(' + words.map(function (w) {
      return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }).join('|') + ')', 'g');
    var names = root.querySelectorAll('.cyb-suggest__main .cyb-suggest__name, .cyb-suggest__item--collection .cyb-suggest__name');
    Array.prototype.forEach.call(names, function (el) {
      var text = el.textContent;
      var folded = fold(text);
      if (folded.length !== text.length) return;
      var out = '', last = 0, m;
      re.lastIndex = 0;
      while ((m = re.exec(folded))) {
        var start = m.index + m[1].length, end = start + m[2].length;
        out += esc(text.slice(last, start)) + '<mark>' + esc(text.slice(start, end)) + '</mark>';
        last = end;
      }
      if (last) el.innerHTML = out + esc(text.slice(last));
    });
  }

  function esc(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initSuggest(form) {
    var input = form.querySelector('input[name="q"]');
    if (!input || form.getAttribute('data-cyb-ready')) return;
    form.setAttribute('data-cyb-ready', '1');
    form.classList.add('cyb-search-form');

    var box = document.createElement('div');
    box.className = 'cyb-suggest';
    box.id = 'CybSuggest-' + Math.random().toString(36).slice(2, 8);
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    form.appendChild(box);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('aria-expanded', 'false');

    var timer = null, controller = null, active = -1, lastQ = '';

    function close() {
      box.hidden = true;
      active = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function open() {
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function options() { return box.querySelectorAll('.cyb-suggest__item'); }

    function setActive(i) {
      var opts = options();
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      for (var k = 0; k < opts.length; k++) {
        opts[k].classList.toggle('is-active', k === active);
        opts[k].setAttribute('aria-selected', k === active ? 'true' : 'false');
      }
      opts[active].scrollIntoView({ block: 'nearest' });
    }

    function show(raw, html) {
      if (raw !== lastQ) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var section = doc.getElementById('shopify-section-' + SECTION_ID) || doc.body;
      box.innerHTML = section.innerHTML;
      highlight(box, raw);
      active = -1;
      if (box.textContent.trim()) open(); else close();
    }

    function fetchSuggest(raw) {
      if (cache[raw]) { show(raw, cache[raw]); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = SUGGEST_URL + '?q=' + encodeURIComponent(raw) +
        '&resources%5Btype%5D=product,collection,query&resources%5Blimit%5D=10&resources%5Blimit_scope%5D=each' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&resources%5Boptions%5D%5Bfields%5D=title,product_type,tag,variants.title,vendor' +
        '&section_id=' + SECTION_ID;
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) { cache[raw] = html; show(raw, html); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var raw = input.value.trim();
      lastQ = raw;
      clearTimeout(timer);
      if (raw.length < 2) { close(); return; }
      timer = setTimeout(function () { fetchSuggest(raw); }, 180);
    });

    input.addEventListener('focus', function () {
      if (box.innerHTML && input.value.trim().length >= 2) open();
    });

    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        window.location.href = options()[active].href;
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) { e.preventDefault(); input.focus(); }
    });
  }

  /* Results page: client-side sort and "in stock only" over the main grid */
  function initToolbar() {
    var other = document.getElementById('CybSearchOther');
    var link = document.querySelector('[data-cyb-open-other]');
    if (other && link) link.addEventListener('click', function () { other.open = true; });

    var bar = document.querySelector('[data-cyb-toolbar]');
    var grid = document.querySelector('[data-cyb-grid]');
    if (!bar || !grid) return;
    bar.hidden = false;
    var sort = bar.querySelector('[data-cyb-sort]');
    var instock = bar.querySelector('[data-cyb-instock]');
    var items = Array.prototype.slice.call(grid.children);

    function apply() {
      var mode = sort.value;
      var sorted = items.slice().sort(function (a, b) {
        if (mode === 'price-asc') return a.dataset.price - b.dataset.price || a.dataset.rank - b.dataset.rank;
        if (mode === 'price-desc') return b.dataset.price - a.dataset.price || a.dataset.rank - b.dataset.rank;
        if (mode === 'title') return a.dataset.title.localeCompare(b.dataset.title, 'ro');
        return a.dataset.rank - b.dataset.rank;
      });
      sorted.forEach(function (el) {
        el.hidden = instock.checked && el.dataset.available !== 'true';
        grid.appendChild(el);
      });
    }

    sort.addEventListener('change', apply);
    instock.addEventListener('change', apply);

  }

  function boot() {
    var forms = document.querySelectorAll('form[data-cyb-search]');
    for (var i = 0; i < forms.length; i++) initSuggest(forms[i]);
    initToolbar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
